import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertPackingEntry = createAsyncThunk('insertPackingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPackingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteDCInfo = createAsyncThunk('deleteDCInfo', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getdeleteDcInfo&pkId=${id}`);
        console.log("api response=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const deleteInvInfo = createAsyncThunk('deleteInvInfo', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getdeleteInvInfo&invId=${id}`);
        console.log("api response=>",response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const insertPackingInvoiceEntry = createAsyncThunk('insertPackingInvoiceEntry', async (postData) => {
    try {
        // const response = await axios.post(`${baseUrl}?apicall=insertPackingInvoiceEntry`, postData);
        const response = await axios.post(`${baseUrl}?apicall=insertMultiplePackingSaleInvoice`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchStkOrderManualbarcode = createAsyncThunk('fetchStkOrderManualbarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockOrderManualnos`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStkOnlyManualbarcode = createAsyncThunk('fetchStkOnlyManualbarcode', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStockManualnosOnly`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchStkSingleRecord = createAsyncThunk('fetchStkSingleRecord', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getStkDataSingleRecord&stkId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPackingSlipMemo = createAsyncThunk('fetchPackingSlipMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getPackingSlipMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPackingData = createAsyncThunk('fetchPackingData', async (id) => {
    try {
        const endpoint = id ? `getPackingEntryData&pkId=${id}` : 'getPackingEntryData';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPackingData2 = createAsyncThunk('fetchPackingData2', async (id) => {
    try {
        const endpoint = `getPackingEntryData&partyId=${id}`;
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchShiftingData = createAsyncThunk('fetchShiftingData', async (id) => {
    try {
        const endpoint = id ? `getStockShiftingdata&pkId=${id}` : 'getStockShiftingdata';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchSaleInvoiceReg = createAsyncThunk('fetchSaleInvoiceReg', async (id) => {
    try {
        const endpoint = id ? `getPackingInvoiceRegister&invId=${id}` : 'getPackingInvoiceRegister';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const packApiSlice = createSlice({
    name: 'PackingDatalist',
    initialState: {
        isLoading: false,
        orderManual: null,
        onlyManual: null,
        singleStk: null,
        packMemo: null,
        pkdata: null,
        saleInv: null,
        shiftdata: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStkOrderManualbarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkOrderManualbarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.orderManual = action.payload;
        });
        builder.addCase(fetchStkOrderManualbarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStkOnlyManualbarcode.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkOnlyManualbarcode.fulfilled, (state, action) => {
            state.isLoading = false;
            state.onlyManual = action.payload;
        });
        builder.addCase(fetchStkOnlyManualbarcode.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchStkSingleRecord.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchStkSingleRecord.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleStk = action.payload;
        });
        builder.addCase(fetchStkSingleRecord.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchPackingSlipMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPackingSlipMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.packMemo = action.payload;
        });
        builder.addCase(fetchPackingSlipMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchPackingData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPackingData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pkdata = action.payload;
        });
        builder.addCase(fetchPackingData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSaleInvoiceReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSaleInvoiceReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.saleInv = action.payload;
        });
        builder.addCase(fetchSaleInvoiceReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchShiftingData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchShiftingData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.shiftdata = action.payload;
        });
        builder.addCase(fetchShiftingData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPackingData2.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPackingData2.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pkdata = action.payload;
        });
        builder.addCase(fetchPackingData2.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default packApiSlice.reducer;
